'use client';

import { useEffect } from 'react';
import Image from "next/image";
import { useAtom } from 'jotai';
import { userInfoAtom } from "@/store/userinfo";
import { showUserCenter, closeUserCenter } from "@/features/user-center";
import { track } from "@/utils/track";
import { unreadCountInfoAtom } from '@/store/notifications';
import userImg from '@/assets/images/common/avatar.png';
import { useNotificationUnreadNum } from '@/features/notifications/services';
import useIsLogin from '@/features/notifications/hooks/useIsLogin';
import NiceModal from '@ebay/nice-modal-react';
import PersonalCenter from '@/features/user-center';
import { AudioId, useAudioHelper } from '@/utils/audio-hepler';

export default function UserCenterEntry() {
  const [useinfo] = useAtom(userInfoAtom);
  const [unreadCountInfo, setUnreadCountInfo] = useAtom(unreadCountInfoAtom);
  const { isLogin } = useIsLogin();
  const modal = NiceModal.useModal(PersonalCenter);
  const { playAudio } = useAudioHelper({ id: AudioId.TurnPage });

  // 获取站内信未读数量，仅在用户登录时请求
  const { data: unreadData, refetch: refetchUnreadNum } = useNotificationUnreadNum({
    enabled: isLogin,
  });

  useEffect(() => {
    if (isLogin) {
      refetchUnreadNum();
    }
  }, [isLogin, refetchUnreadNum]);

  useEffect(() => {
    if (unreadData) {
      setUnreadCountInfo({
        allUnreadCount: unreadData.all_unread_count,
        platformUnreadCount: unreadData.platform_unread_count,
        personalUnreadCount: unreadData.personal_unread_count,
      });
    }
  }, [unreadData, setUnreadCountInfo]);

  const showUserCenterDialog = () => {

    console.log('User center clicked'); // 调试用
    track('profile_button_click', {});
    // 检查弹窗是否已经打开
    if (modal.visible) {
      closeUserCenter();
    } else {
      showUserCenter();
    }
    playAudio();
  };


  return (
    <>
      <div
        className={`relative w-8 h-8 mt-[3px] flex items-center justify-center transition-transform duration-150 cursor-pointer select-none active:scale-90`}
        onClick={() => {
          showUserCenterDialog();
        }}
        data-user-center-entry
      >
        <Image
          unoptimized
          className="rounded-[8px] pointer-events-none"
          src={useinfo?.avatarUrl || userImg}
          alt="user"
          width={30}
          height={30}
          priority
        />
        {
          Boolean(unreadCountInfo.allUnreadCount) && (
            <div className="absolute top-[-4px] right-[-3px] px-[3px] min-w-[11px] h-[11px] flex items-center justify-center bg-accent-red text-white text-[9px] rounded-full pointer-events-none">{unreadCountInfo.allUnreadCount > 99 ? '99+' : unreadCountInfo.allUnreadCount}</div>
          )
        }
      </div>
    </>
  );

}